import React, { Fragment, useEffect,useRef } from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Chip from '@material-ui/core/Chip';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EyepieceOneResult from 'components/EyepieceOneResult';
import EyepieceOneResource from 'components/EyepieceOneResource';
import TabPanel from 'utils/components/TabPanel';
import a11yProps from 'utils/a11yProps';

const useStyles = makeStyles(theme => ({
  appbar: {
    marginTop: theme.spacing(3)
  }
}));

function Eyepiece1() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
 
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Fragment>


      <AppBar className={classes.appbar}  position="static" color="transparent" elevation={0}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="menu tabs"
        >
          <Tab label="Survey" {...a11yProps(0)} />
          <Tab label="Results" {...a11yProps(1)} />
          <Tab label="Resources" {...a11yProps(2)} />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <Button variant="contained" color="primary" target="_blank" href="https://rer.qualtrics.com/jfe/form/SV_eQGqNOz2DNFQ6KW" color="primary">
  Take Survey
</Button>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <EyepieceOneResult/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <EyepieceOneResource/>
      </TabPanel>
    </Fragment>
  );
}

export default Eyepiece1;
